import { Node, mergeAttributes } from '@tiptap/core';

export const ActHeading = Node.create({
  name: 'actHeading',
  group: 'block',
  content: 'inline*',

  parseHTML() {
    return [{ tag: 'p[data-type="act-heading"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'p',
      mergeAttributes(HTMLAttributes, {
        'data-type': 'act-heading',
        class: 'play-act-heading',
        spellcheck: 'false',
      }),
      0,
    ];
  },
});
